import { Condition } from '@luminovo/api-contracts';

import { Formula } from './Formula';
import { convertConditionToFormulaNodes } from './model/convertConditionToFormulaNodes';

export function ConditionFormula({ condition }: { condition: Condition }): JSX.Element {
    return <Formula nodes={convertConditionToFormulaNodes(condition)} />;
}
